export default __webpack_public_path__ + "static/media/loopstudios.da7164af.png";